import { h as c, Y as m } from "./register-Ba9sFUKZ.js";
import { h } from "./lifecycle-decorators-C04d1yHY.js";
import { f } from "./query-assigned-elements-CMnZBBH0.js";
import { u } from "./showIfUsed-5lEKgJ0L.js";
import { t as v } from "./uid-DGLBmjXH.js";
var b = Object.defineProperty, E = Object.getOwnPropertyDescriptor, o = (n, e, t, i) => {
  for (var r = i > 1 ? void 0 : i ? E(e, t) : e, s = n.length - 1, a; s >= 0; s--)
    (a = n[s]) && (r = (i ? a(e, t, r) : a(r)) || r);
  return i && r && b(e, t, r), r;
};
function j(n) {
  let e = class extends n {
    constructor() {
      super(...arguments), this.disabled = !1, this.allowableInteractiveKeys = ["Shift", "Tab"], this.preventDisabledEvents = (t) => {
        if (this.disabled)
          if (t instanceof KeyboardEvent) {
            const { key: i } = t;
            this.allowableInteractiveKeys.includes(i) || t.preventDefault();
          } else
            t.preventDefault();
      };
    }
    preventDisabledEventsOnElement(t, i = ["click", "keydown"]) {
      for (const r of i)
        t == null || t.addEventListener(r, this.preventDisabledEvents);
    }
  };
  return o([
    c({ type: Boolean, reflect: !0 })
  ], e.prototype, "disabled", 2), e = o([
    h("Disablable")
  ], e), e;
}
var y = Object.defineProperty, g = Object.getOwnPropertyDescriptor, d = (n) => {
  throw TypeError(n);
}, l = (n, e, t, i) => {
  for (var r = i > 1 ? void 0 : i ? g(e, t) : e, s = n.length - 1, a; s >= 0; s--)
    (a = n[s]) && (r = (i ? a(e, t, r) : a(r)) || r);
  return i && r && y(e, t, r), r;
}, p = (n, e, t) => e.has(n) || d("Cannot " + t), w = (n, e, t) => (p(n, e, "read from private field"), t ? t.call(n) : e.get(n)), D = (n, e, t) => e.has(n) ? d("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(n) : e.set(n, t), O = (n, e, t, i) => (p(n, e, "write to private field"), e.set(n, t), t);
function x(n) {
  var e;
  let t = class extends n {
    constructor() {
      super(...arguments), D(this, e);
    }
    get hintElement() {
      return w(this, e);
    }
    set hintElement(i) {
      O(this, e, i), this.hintElement && !this.hintElement.id && (this.hintElement.id = v()), this.postSetHintElement();
    }
    postSetHintElement() {
    }
    handleHintSlotchange() {
      this.hintElement = this.hintElements[0];
    }
    renderHintTemplate() {
      return m`
        <div id="hint" class="hint">
          <slot
            name="hint"
            @slotchange=${this.handleHintSlotchange}
            ${u({ useParent: !0 })}></slot>
        </div>
      `;
    }
  };
  return e = /* @__PURE__ */ new WeakMap(), l([
    f({ flatten: !0, slot: "hint" })
  ], t.prototype, "hintElements", 2), t = l([
    h("Hintable")
  ], t), t;
}
export {
  x as O,
  j as v
};
